import { render } from "./TpPage.vue?vue&type=template&id=35b6840f&scoped=true"
import script from "./TpPage.vue?vue&type=script&lang=js"
export * from "./TpPage.vue?vue&type=script&lang=js"

import "./TpPage.vue?vue&type=style&index=0&id=35b6840f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b6840f"]])

export default __exports__